import React, { useState } from 'react';

export default function FacetFilter({ facets, onChange }) {
  // facets = [ { name: 'Brand', options: ['Apple','Samsung'] }, ... ]
  const initial = Object.fromEntries(facets.map((f) => [f.name, []]));
  const [selected, setSelected] = useState(initial);

  function toggle(facetName, option) {
    const current = selected[facetName];
    const updated = current.includes(option)
      ? current.filter((o) => o !== option)
      : [...current, option];
    const next = { ...selected, [facetName]: updated };
    setSelected(next);
    onChange(next);
  }

  return (
    <div className="facet-filter">
      {facets.map(({ name, options }) => (
        <fieldset key={name} className="facet-filter__group">
          <legend>{name}</legend>
          {options.map((opt) => (
            <label key={opt}>
              <input
                type="checkbox"
                checked={selected[name].includes(opt)}
                onChange={() => toggle(name, opt)}
              />
              {opt}
            </label>
          ))}
        </fieldset>
      ))}
    </div>
  );
}
